import {pageInfo,importData,downtemplate, exportData} from './../api';
import {Message} from 'element-ui';

const qcResult = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    importDataObj: [],
    exportObj: [],
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    IMPORT_DATA(state, data) {
      state.importDataObj = data;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async importData({commit}, obj) {
      let resp = await importData(obj);
      commit('IMPORT_DATA', resp);
    },
    //下载模板
    async template({ commit }, obj) {
      let resp = await downtemplate(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
  }
}
export default qcResult



// WEBPACK FOOTER //
// ./src/page/bd/qc/qcResult/store/qcResult.store.js